import React, { Component } from 'react';
import './logoClients.css'

class Clients extends Component {
    render() {

            let {classDiv } = this.props;

        return (
            <div className={` ${classDiv} `}>
                <div className="logos ">
                    <figure className="imgClients">
                        <img src={require('img/clients/logo-target.png')} alt="Logo Client  Target" loading="lazy" />
                    </figure>
                </div>                               
                <div className="logos">
                    <figure className="imgClients">
                        <img src={require('img/clients/logo-square-trade.png')} alt="Logo Client  Square Trade" loading="lazy" />
                    </figure>
                </div>
                <div className="logos">
                    <figure className="imgClients">
                        <img src={require('img/clients/logo-falabella.png')} alt="Logo Client  Falabella" loading="lazy" />
                    </figure>    
                </div>
                <div className="logos">
                    <figure className="imgClients">
                        <img src={require('img/clients/logo-pycca.png')} alt="Logo Client  Pycca" loading="lazy" />
                    </figure>
                </div>
                <div className="logos">
                    <figure className="imgClients">
                        <img src={require('img/clients/logo-sequoia.png')} alt="Logo Client  Sequoia" loading="lazy" />
                    </figure>
                </div>
                <div className="logos">
                    <figure className="imgClients">
                        <img src={require('img/clients/logo-bolivar.png')} alt="Logo Client  Bolivar" loading="lazy" />
                    </figure>
                </div>
                <div className="logos">
                    <figure className="imgClients">
                        <img src={require('img/clients/logo-listo-seguro.svg').default} alt="Logo Client  Movizzon" loading="lazy" />
                    </figure>
                </div>
                <div className="logos">
                    <figure className="imgClients">
                        <img src={require('img/clients/logo-movizzon.svg').default} alt="Logo Client  Movizzon" loading="lazy" />
                    </figure>
                </div>
                <div className="logos">
                    <figure className="imgClients">
                        <img src={require('img/clients/logo-phonecheck.png')} alt="Logo Client  Phonecheck" loading="lazy" />
                    </figure>
                </div>
                <div className="logos">
                    <figure className="imgClients">
                        <img src={require('img/clients/logo-miraclon.png')} alt="Logo Client  Miraclon" loading="lazy" />
                    </figure>
                </div>
                <div className="logos">
                    <figure className="imgClients">
                        <img src={require('img/clients/logo-global-networks.png')} alt="Logo Client  Global Networks" loading="lazy" />
                    </figure>
                </div>
                <div className="logos">
                    <figure className="imgClients">
                        <img src={require('img/clients/logo-auxis.svg').default} alt="Logo Client  Auxis" loading="lazy" />
                    </figure>
                </div>
            </div>
        );
    }
}

export default Clients;
